import { boolean, customType, index, integer, jsonb, pgEnum, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core';
import * as z from 'zod';
import { user } from './auth.js';
import { reportTabEnum } from './reports.js';
import { timestamps } from './utils/index.js';
import { uuidv7 } from './utils/uuidv7.js';
/** Lifecycle of an export that runs in the background instead of in the request (CY-86). */
export const ReportExportStatus = z.enum(['queued', 'running', 'ready', 'failed']);
export const reportExportStatusEnum = pgEnum('report_export_status', [
    ReportExportStatus.enum.queued,
    ReportExportStatus.enum.running,
    ReportExportStatus.enum.ready,
    ReportExportStatus.enum.failed,
]);
/** The built file; kept in the row because the worker and the server do not share a filesystem. */
const bytea = customType({ dataType: () => 'bytea' });
/**
 * One row per background export: the request is kept so the worker can build the file after the
 * response, and `userId` is what makes the finished file downloadable by its requester only.
 */
export const reportExports = pgTable('report_exports', {
    id: uuidv7('id').primaryKey(),
    userId: uuid('user_id')
        .notNull()
        .references(() => user.id),
    tab: reportTabEnum('tab').notNull(),
    format: text('format').notNull(),
    columnIds: jsonb('column_ids').$type().notNull(),
    filters: jsonb('filters').$type(),
    sort: jsonb('sort').$type(),
    includeIdentifiers: boolean('include_identifiers').notNull().default(false),
    locale: text('locale').notNull(),
    timezone: text('timezone'),
    labels: jsonb('labels').$type().notNull(),
    header: jsonb('header').$type().notNull(),
    status: reportExportStatusEnum('status').notNull().default('queued'),
    rowCount: integer('row_count'),
    /** the built file itself, cleared with the row when the export expires */
    data: bytea('data'),
    filename: text('filename'),
    contentType: text('content_type'),
    error: text('error'),
    completedAt: timestamp('completed_at'),
    // set once the requester has been told the export finished, so it is announced exactly once
    acknowledgedAt: timestamp('acknowledged_at'),
    // the file and the row are dropped once they expire; the audit event stays
    expiresAt: timestamp('expires_at').notNull(),
    ...timestamps(),
}, t => [index('idx_report_exports_user_created').on(t.userId, t.createdAt)]);
//# sourceMappingURL=report-exports.js.map